<!-- eslint-disable vue/no-v-html -->
<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-left bg-no-repeat"
    :style="bannerStyle"
  >
    <div class="container-wrap flex h-mobile-banner py-2 tablet:h-banner">
      <div class="flex w-full flex-col justify-center">
        <div>
          <h1 class="text-h1 banner-title mb-2">{{ t('title') }}</h1>
          <p
            class="banner-description is-mobile-hidden mb-3"
            v-html="decode(t('description'))"
          />
        </div>
        <TheButton
          class="w-[250px]"
          :to="`/${locale}/marketplace/webinars`"
          :title="t('item-button')"
        >
          <span class="text-sm">{{ t('item-button') }}</span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { decode } from 'entities';

  const { t, locale } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();
  const { isCN } = useLanguage();

  const bannerStyle = computed((): string => {
    const imageUrl = isCN.value
      ? `${blobDomain.value}/wise-paas-marketplace/news/news_banner.webp`
      : `${blobDomain.value}/wise-paas-marketplace/news/banner.webp`;

    return `background-image: url(${imageUrl})`;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "en-jp": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "en-tw": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "en-kr": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "en-americas": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "en-asia-pacific": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "en-emea": {
    "title": "Browse the latest announcements, news, and insights",
    "description": "Stay well-informed with news, insights, and resources.<br/>Explore our IoT products and solutions to gain deeper business insights and implement them effectively.",
    "item-button": "Visit Events & Webinars"
  },
  "ja-jp": {
    "title": "最新のアナウンス、ニュース、インサイトをご覧ください。",
    "description": "最新のニュース、専門家の洞察、リソースをご覧ください。 当社のIoT製品やソリューションの詳細をご覧いただき、<br/>お客様のビジネス展開やデジタルトランスフォーメーションにお役立てください。",
    "item-button": "イベントやウェビナーを見る"
  },
  "zh-cn": {
    "title": "新闻中心",
    "description": "实时新闻速览，热点资讯回顾",
    "item-button": "访问市场活动中心"
  },
  "zh-tw": {
    "title": "掌握最新公告、新聞與資源",
    "description": "隨時掌握最新消息、專家見解和相關資源。了解更多關於我們的物聯網產品和解決方案，並將其應用於您的業務發展與數位轉型。",
    "item-button": "造訪活動與網路研討會"
  }
}
</i18n>
